import { render, staticRenderFns } from "./PaymentOfferSendButton.vue?vue&type=template&id=5446f628&scoped=true"
import script from "./PaymentOfferSendButton.vue?vue&type=script&lang=ts"
export * from "./PaymentOfferSendButton.vue?vue&type=script&lang=ts"
import style0 from "./PaymentOfferSendButton.vue?vue&type=style&index=0&id=5446f628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5446f628",
  null
  
)

export default component.exports